var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 21C5.486 21 1 16.514 1 11S5.486 1 11 1s10 4.486 10 10-4.486 10-10 10zm0-19.394C5.82 1.606 1.606 5.82 1.606 11S5.82 20.394 11 20.394 20.394 16.18 20.394 11 16.18 1.606 11 1.606z",
    stroke: "currentColor",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 21c-2.112 0-4.141-.642-5.87-1.857a.303.303 0 0 1-.127-.287.304.304 0 0 1 .198-.244c2.549-.932 2.96-1.688 2.96-3.137 0-.383-.087-.509-.245-.737-.208-.3-.494-.71-.694-1.783-.03-.154-.055-.166-.194-.233-.373-.177-.715-.432-.805-1.595 0-.563.197-.874.36-1.036-.036-.2-.094-.546-.15-.922-.278-1.685-.29-3.749 2.111-4.708 2.093-.838 3.764-.38 4.288.165.371.012 1.33.108 1.996.873 1.025 1.177.699 3.861.587 4.589.163.158.362.465.362 1.016-.09 1.186-.432 1.441-.805 1.618-.14.067-.166.078-.195.233-.2 1.073-.485 1.483-.693 1.783-.158.228-.245.354-.245.737 0 1.449.411 2.205 2.96 3.137a.303.303 0 0 1 .072.531A10.162 10.162 0 0 1 11 21z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderProfileIcon);
export default __webpack_public_path__ + "static/media/header-profile-icon.ccb39de76e1c0545f7d7885b5e1c1937.svg";
export { ForwardRef as ReactComponent };